<!--
  --
  -- フッタリンク項目 コンポーネント
  --
  -->
<template>
  <a
    class="mx-1"
    target="_blank"
    :href="link.url"
    v-text="link.caption"
  />
</template>

<script>
export default {
  name: 'CChip',
  props: {
    link: {
      type: Object,
      required: true
    }
  }
}
</script>
